import { LCDocumentEditorService } from './LCDocumentEditorService';
import { JSErrorHandling } from './../JSErrorHandling';
import { LectioJSUtils } from './../LectioJSUtils';
import { IBasicTextField } from './Types';

export class LCLinkTitleLoop {
	public static setup(linkTbId: string, titleTbId: string, statusDivId: string, okBtnId: string) {

		const linkTb = $('#' + linkTbId);
		const titleTb = $('#' + titleTbId);
		const statusDiv = $('#' + statusDivId);
		const okBtn = $('#' + okBtnId);

		okBtn.button('disable');

		const linkValObs = Rx.Observable.merge([
			Rx.Observable.fromEvent(linkTb[0], 'change'),
			Rx.Observable.fromEvent(linkTb[0], 'input').debounce(400)
		]).select(() => (linkTb.val() as string).trim());

		LCLinkTitleLoop.create(linkValObs, LCLinkTitleLoop.wrapHtmlInput(titleTb[0] as HTMLInputElement),
			(status, valid) => {
				statusDiv.text(status);
				if (valid)
					okBtn.button('enable');
				else
					okBtn.button('disable');
			});
	}

	public static wrapHtmlInput(htmlInput: HTMLInputElement): IBasicTextField {
		return {
			getValue: () => htmlInput.value,
			setValue: (val: string) => htmlInput.value = val
		};
	}

	public static wrapUIElement(htmlInput: CKEDITOR.ui.dialog.uiElement): IBasicTextField {
		return {
			getValue: () => htmlInput.getValue(),
			setValue: (val: string) => htmlInput.setValue(val)
		};
	}

	public static create(
		linkValObs: Rx.Observable<string>,
		titleTb: IBasicTextField,
		setStatus: {
			(errorMessage: string, isValid: boolean): void
		}): void {

		const linkValObs2 = linkValObs
			.where(url => (url !== ''))
			.distinctUntilChanged();

		let xhrPrev: JQueryXHR | null = null;
		let origTitle = '';
		linkValObs2.subscribe(url => {
			if (xhrPrev !== null) {
				const tmp = xhrPrev;
				xhrPrev = null;
				tmp.abort();
			}

			origTitle = titleTb.getValue();
			const xhr = LCDocumentEditorService.GetUrlTitle(url);
			xhrPrev = xhr;
			setStatus('Henter titel...', false);
			xhr.then(() => {
				type reply = { error?: string, title: string };
				let response: reply;
				//STM 30127
				try {
					const title = xhr.responseJSON.replace(/'/g, '"');
					response = JSON.parse(title) as reply;
				} catch (e: any) {
					LectioJSUtils.LogWarn(e);
					JSErrorHandling.reportJSError(e);
					setStatus(url, true);
					return;
				}

				if (response.error) {
					setStatus(response.error, /adgang/.test(response.error || ''));
					titleTb.setValue("Titel");
					return;
				}
				if (titleTb.getValue() !== origTitle) {
					setStatus('', true);
					return;
				}

				// stm 46653: Lille hack for at decode danske karakterer, e.g. &#216; -> Ø
				const decoded = document.createElement('textarea');
				decoded.innerHTML = response.title;

				titleTb.setValue(decoded.value);
				setStatus('', true);
				LectioJSUtils.DispatchBrowserTestEvent('linkLoopOk');
			}, () => {
				setStatus(url, true);
			});
		});
	}

	public static createOembedLoopOverload(
		linkTbId: string, statusDivId: string, okBtnId: string,
		events: { element: HTMLElement, event: string, debounce?: number }[],
		sendSelectionToHostCb: (a: any) => void
	): void {

		const linkTb = $('#' + linkTbId);
		const statusDiv = $('#' + statusDivId);
		const okBtn = $('#' + okBtnId);

		statusDiv.width(statusDiv.width() as number);
		okBtn.button('disable');

		const mapped = events.map(o => {
			let observable = Rx.Observable.fromEvent(o.element, o.event);

			if (o.debounce) {
				observable = observable.debounce(400);
			}

			return observable;
		});

		const linkValObs = Rx.Observable.merge(mapped).select(() => (linkTb.val() as string).trim());

		let currentEmbedMarkup = '';

		LCLinkTitleLoop.createOembedLoop(linkValObs, (statusObj: any) => {
			let status: string;
			switch (statusObj.type) {
			case 'working':
				status = 'Der arbejdes...';
				currentEmbedMarkup = '';
				break;
			case 'markup':
				status = 'Ok';
				LectioJSUtils.AssertNotNullOrEmpty(statusObj.embedMarkup, 'statusObj.embedMarkup');
				currentEmbedMarkup = statusObj.embedMarkup;
				$(document).trigger('lectiooembedresolvedok');
				break;
			case 'error':
				status = statusObj.error;
				currentEmbedMarkup = '';
				break;
			default:
				throw new Error('Uventet type: ' + statusObj.type);
			}
			statusDiv.text(status);
			okBtn.button(statusObj.type === 'markup' ? 'enable' : 'disable');
		});

		okBtn.on('click', () => {
			LectioJSUtils.AssertNotNullOrEmpty(currentEmbedMarkup, 'currentEmbedMarkup');
			sendSelectionToHostCb({ type: 'html', html: currentEmbedMarkup });
		});
	}

	public static createOembedLoop(
		linkValObs: Rx.Observable<string>,
		setStatus: (v: {
			type: 'markup',
			embedMarkup: string
		} |
		{
			type: 'error',
			error: string
		} |
		{ type: 'working' }) => void
	): void {
		const linkValObs2 = linkValObs
			.where(url => {
				if (!url) {
					setStatus({ type: 'error', error: '' });
					return false;
				}

				const looksLikeUrl = !!url.match(/^(http|https):\/\/[a-zA-Z.-_]+(\/|$)/);
				if (!looksLikeUrl) {
					setStatus({ type: 'error', error: 'Ugyldigt format' });
					return false;
				}

				return looksLikeUrl;
			})
			.distinctUntilChanged();

		let xhrPrev: JQueryXHR | null = null;
		const origTitle = '';
		linkValObs2.subscribe(url => {
			if (xhrPrev !== null) {
				const tmp = xhrPrev;
				xhrPrev = null;
				tmp.abort();
			}

			const xhr = LCDocumentEditorService.GetOembedMarkup(url);
			xhrPrev = xhr;
			setStatus({ type: 'working' });
			xhr.then(() => {

				if (typeof xhr.responseJSON !== 'string') {
					setStatus({ type: 'error', error: 'Intern fejl' });
					throw new Error('Uventet type: ' + typeof xhr.responseJSON);
				}
				const embedMarkup = xhr.responseJSON;

				setStatus({ type: 'markup', embedMarkup: embedMarkup });
			}, () => {
				setStatus({ type: 'error', error: xhr.responseText || 'Der opstod en fejl.' });
			});
		});
	}
}
